module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","dateFormat":{"dateTimePattern":"YYYY-MM-DD hh:mm A"},"delete":"Delete","deleteMediationPeriod":"Delete mediation period","from":"from","to":"to"},"fr":{"cancel":"Annuler","dateFormat":{"dateTimePattern":"DD/MM/YYYY HH:mm"},"delete":"Supprimer","deleteMediationPeriod":"Suppression d\u0027une période","from":"du","to":"au"}}')
  delete Component.options._Ctor
}
